'use strict';

var _ = require('lodash');
var TrueODService = function TrueODService(AirlineColorService) {
  function isParsableToNumber(numberStr) {
    return !_.isNaN(parseInt(numberStr));
  }
  function getOrigin(segmentDetail) {
    return segmentDetail[0];
  }
  function getDestination(segmentDetail) {
    if (isParsableToNumber(segmentDetail[5])) {
      return segmentDetail[6];
    } else {
      return segmentDetail[5];
    }
  }
  function getAirlineName(segmentDetails) {
    return segmentDetails[3];
  }
  function getFlightNumber(segmentDetails) {
    if (isParsableToNumber(segmentDetails[5])) {
      return segmentDetails[5];
    } else {
      return segmentDetails[4];
    }
  }
  function reduceDuplicatedBookings(tripBookings) {
    var groupedSegments = _.groupBy(tripBookings, 'allLabels');
    return _.map(groupedSegments, function (duplicatedSegments) {
      var initial = _.cloneDeep(_.first(duplicatedSegments));
      initial.bkgs = 0;
      return _.reduce(duplicatedSegments, function (result, value) {
        result.bkgs += value.bkgs || 0;
        return result;
      }, initial);
    });
  }
  function transformSegment(segment) {
    var segmentDetails = _.split(segment, '.');
    var origin = getOrigin(segmentDetails);
    var airlineCode = getAirlineName(segmentDetails);
    var destination = getDestination(segmentDetails);
    var flightNumber = getFlightNumber(segmentDetails);
    return {
      airlineCode: airlineCode,
      origin: origin,
      destination: destination,
      flightNumber: flightNumber
    };
  }
  function groupByArlineCode(groupedByAirlineCode) {
    return function (segment, index) {
      if (index === 0) {
        groupedByAirlineCode[0] = [segment];
        return;
      }
      var last = _.last(groupedByAirlineCode);
      if (last[0].airlineCode === segment.airlineCode) {
        last.push(segment);
      } else {
        groupedByAirlineCode.push([segment]);
      }
    };
  }
  function transformGrouped(carrier) {
    return function (groupedSegments) {
      var airlineCode = _.first(groupedSegments).airlineCode;
      var origin = _.first(groupedSegments).origin;
      var destination = _.last(groupedSegments).destination;
      var suffix = carrier !== airlineCode ? ' (' + airlineCode + ')' : '';
      var color = AirlineColorService.getColorForAirline(airlineCode);
      var label = origin + '-' + destination + suffix;
      return {
        airlineCode: airlineCode,
        origin: origin,
        destination: destination,
        color: color,
        label: label
      };
    };
  }
  function parseSegments(pipeSeparated, carrier) {
    var groupedByAirlineCode = [];
    _.split(pipeSeparated, '|').map(transformSegment).forEach(groupByArlineCode(groupedByAirlineCode));
    return _.map(groupedByAirlineCode, transformGrouped(carrier));
  }
  function transformToRows(tripBookings, carrier) {
    var trueOD = _.map(tripBookings, function (tripElement) {
      var parsedSegments = parseSegments(tripElement.tripId, carrier);
      var marketOrigin = _.first(parsedSegments).origin;
      var marketDestination = _.last(parsedSegments).destination;
      var allLabels = _.map(parsedSegments, 'label').join('|');
      return {
        market: marketOrigin + '-' + marketDestination,
        bkgs: tripElement.total,
        constructions: parsedSegments,
        allLabels: allLabels
      };
    });
    return reduceDuplicatedBookings(trueOD);
  }
  return {
    transformToRows: transformToRows
  };
};
TrueODService.$inject = ['AirlineColorService'];
module.exports = TrueODService;